import { Box } from "@mui/material";
import { pageContents } from "./styles";

const PageContents = ({ children }) => {
  return <Box sx={(theme) => pageContents(theme)}>{children}</Box>;
};

export default PageContents;
